import './style/yearCalendar.scss';

import React, {useContext} from 'react';
import CalendarItem from '../../../models/calendarItemModel';
import EditableHeader from "../../editor/editableHeader";
import {ContentContext} from "../../context/contentContext";
import {Language} from "../../../util/enums";
import {EN_WEEKDAYS, NL_WEEKDAYS} from "../../../util/calendarUtil";
import {Loader} from '@dvrd/dvr-controls';
import EditableList from "../../editor/editableList";

interface Props {
    items: Array<CalendarItem>;
    loading: boolean;
}

export default function YearCalendar(props: Props) {
    const {language} = useContext(ContentContext);
    const {items, loading} = props;

    function renderHead() {
        return (
            <div className='default-table-row calendar-item-row head'>
                <div/>
                <label className='span-2 bold'>{language === Language.EN ? 'From' : 'Van'}</label>
                <label className='span-2 bold'>{language === Language.EN ? 'To' : 'Tot'}</label>
            </div>
        )
    }

    function renderItem(item: CalendarItem, index: number) {
        const fromWeekDay = item.fromDate.weekday();
        const toWeekDay = item.toDate?.weekday();
        return (
            <div key={index} className='default-table-row calendar-item-row'>
                <label className='bold'>{language === Language.EN ? item.ENLabel : item.NLLabel}</label>
                <label>{language === Language.EN ? EN_WEEKDAYS[fromWeekDay - 1] : NL_WEEKDAYS[fromWeekDay - 1]}</label>
                <label>{item.fromDate.format('DD-MM-YYYY')}</label>
                <label>{!toWeekDay ? '' :
                    language === Language.EN ? EN_WEEKDAYS[toWeekDay - 1] : NL_WEEKDAYS[toWeekDay - 1]}</label>
                <label>{item.toDate?.format('DD-MM-YYYY') ?? ''}</label>
            </div>
        );
    }

    return (
        <div className='default-page year-calendar-page'>
            <EditableHeader textKey='year-calendar-head-1' className='page-title'/>
            <section className='section'>
                <div className='calendar-items-container'>
                    <Loader active={loading}/>
                    {renderHead()}
                    {items.map(renderItem)}
                </div>
            </section>
            <section className='section'>
                <EditableHeader textKey='year-calendar-head-2' className='section-title' headerType='h2'/>
                <EditableList textKey='year-calendar-list-1'  className='item-list'/>
            </section>
        </div>
    );
}

YearCalendar.displayName = 'AgendaPage';